import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter, CurrencyFormatter} from "../../../utils/formatters";
import Select from "../../form/Select";

class VoucherList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "VoucherList"}
                {...props}
                columns={{
                    "barcode": {
                        header: 'Vonalkód',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "serial_number": {
                        header: 'Ellenőrző kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "amount": {
                        header: 'Érték',
                        width: 3,
                        renderer: CurrencyFormatter,
                        className: "currency",
                        filterable,
                        sortable
                    },
                    "sold": {
                        header: 'Eladva',
                        width: 3,
                        renderer: (sold) => sold ? "Eladva" : "Nincs eladva",
                        sortable,
                        filterable: <Select
                            storeType="local"
                            options={[
                                {key: "0", label: "Nincs eladva"},
                                {key: "1", label: "Eladva"}
                            ]}
                            label={false}
                            objectValue={false}
                            isClearable={true}
                            valueKey="key"
                            labelKey="label"
                        />
                    },
                    "used": {
                        header: 'Beváltva',
                        width: 3,
                        renderer: (sold) => sold ? "Beváltva" : "Nincs beváltva",
                        sortable,
                        filterable: <Select
                            storeType="local"
                            options={[
                                {key: "0", label: "Nincs beváltva"},
                                {key: "1", label: "Beváltva"}
                            ]}
                            label={false}
                            objectValue={false}
                            isClearable={true}
                            valueKey="key"
                            labelKey="label"
                        />
                    },
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default VoucherList;
